export default [
	{
	  title: '尾款支付列表',
	  name: 'orderList'
	},
	{
	  title: '支付信息',
	  name: 'payInfo'
	},
	{
	  title: '鸭题库学员发货地址确认',
	  name: 'orderConfirm'
	}
  ]



// WEBPACK FOOTER //
// ./src/route/orderRouter.js